<template>
<b-modal id="rules-modal" title="About">
    <div class="modal-body text-center"> 
        <div class="row justify-content-center">
            <div class="col-12">
                <section class="content-block">
                    <header class="header mb-3">What is Forever Story?</header>
                    <p>
                        Forever Story is a social story platform with all records stored indefinitely on the Nebulas Blockchain. 
                        Stories do not end, and they have no limit. Any one could contribute at anytime - forever. 
                    </p>
                </section>
            </div>
        </div>          
    </div>
    <div slot="modal-footer" class="modal-footer-inner">
        <button type="button" class="btn btn-secondary" @click="hideModal">
            Close
        </button>
    </div>
</b-modal>
</template>
 
<script>
import { mapGetters } from "vuex";

export default {
    name: "modal-rules",
    computed: {
        ...mapGetters({
            pendingTransaction: 'getPendingTransaction'
        })  
    },
    methods: {
        hideModal () {
            this.$root.$emit('bv::hide::modal','rules-modal');
        }
    }
};
</script>

<style scoped lang="less">
header {
    font-size: 16px;
    font-weight: bold;
}
</style>




// WEBPACK FOOTER //
// src/components/ModalRules.vue